import './App.css';
import React, { useState, useEffect, useRef, Component } from "react";
import { Route, Switch, Redirect } from 'react-router-dom';
import { HashRouter } from 'react-router-dom';
import PreLoginPage from './features/user/PreLoginPage';
import LoginPage from './features/user/LoginPage';
import FreeTrialPage from './features/user/FreeTrialPage';
import HomePage from './app/HomePage';
import MapPage from './features/map/MapPage';
import SearchPoiPage from './features/pois/SearchPoiPage';
import FeaturedPoisPage from './features/pois/FeaturedPoisPage';
import TrendingPoisPage from './features/pois/TrendingPoisPage';
import PoiDetailsPage from './features/pois/PoiDetailsPage';
import SocialWallPage from './app/SocialWallPage';
import ProfilePage from './features/user/ProfilePage';
import PreferredPoisPage from './features/pois/PreferredPoisPage';
import CardPage from './features/card/CardPage';
import { login, verifyPassword, loggedOut, selectTrial } from
        './features/user/userSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';
import TrialEndModal from './features/user/TrialEndModal';
import ErrorMessage from './app/ErrorMessage';
import { getCardStatus, getPosition } from './api/mobile';
import ScrollToTop from './app/ScrollToTop';
import Splash from './app/Splash';
import { selectAllStrings } from './features/language/languageSlice';
import PullToRefresh from 'pulltorefreshjs';
import IOSRegsitrationPage from './features/user/IOSRegsitrationPage';
import ThankYouPage from './features/user/ThankYouPage';
import { getUdid } from './api/mobile';


const Header = () => {
    const isLoggedIn = () => window.localStorage.getItem('loggedIn') == 'true';
    const [error, setError] = useState('');

    const location = useLocation();
    const history = useHistory();
    const trial = useSelector(selectTrial);
    const publicRoutes = [
        '/',
        '/login',
        '/free-trial',
        '/ios-registration',
        '/thank-you'
    ];
    const [authChecked, setAuthChecked] = useState(false);

    const dispatch = useDispatch();


    const checkAuth = async () => {
        if (isLoggedIn()) {
            let cardStatus = await getCardStatus();
            try {
                dispatch(login(cardStatus));
            } catch (err) {
                setError(err.message);
            }
        }
    };
    const dayInMilliseconds = 1000 * 60 * 60 * 24;
    useEffect(() => {
        if (!authChecked) {
            checkAuth();
            setAuthChecked(true);
            setInterval(() => setAuthChecked(false), dayInMilliseconds);
        }
    }, [authChecked, trial]);



    return publicRoutes.indexOf(location.pathname) === -1 && !isLoggedIn() ? <Redirect to="/"/> : <div>
        {trial.status == 'expired' && publicRoutes.indexOf(location.pathname) === -1 ? <TrialEndModal/> :
                        error ? <ErrorMessage message={error} onGoBack={() => setError('')}/> :
                        null}
    </div>
};

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: '',
            positionRequestStatus: 'pending'
        };
    }
    async updatePosition() {
        const position = await getPosition(false);
        if (position) {
            this.setState({
                positionRequestStatus: 'succeeded'
            });
        } else {
            this.setState({
                error: 'Something went wrong'
            });
        }
    }
    async componentDidMount() {
        if (this.state.positionRequestStatus === 'pending') {
            this.updatePosition();
        }
        PullToRefresh.init({
            mainElement: 'body',
            refreshTimeout: 1200,
            distThreshold: 120,
            distMax: 150,
            distIgnore: 90,
            onRefresh() {
                localStorage.setItem('hash', location.hash.replace('#', ''));
                location.href = location.pathname;
            }
        });
//        await getUdid();
//        if(typeof window.udid !== 'undefined' && 
//                window.udid === '57A39C72-8444-4FDC-BABF-57C319CBD28D'
//                && window.location.port != 3000) {
//            
//            window.location = 'http://192.168.1.102:3000';
//        }
    }
    componentWillUnmount() {
        PullToRefresh.destroyAll();
    }
    render() {
        const isLoggedIn = () => window.localStorage.getItem('loggedIn') == 'true';
        const hash = window.localStorage.getItem('hash');
        window.localStorage.removeItem('hash');

        return this.state.error ? <div>{this.state.error}</div> : <HashRouter>
        
            <div className="App">
                <Header/>
                <ScrollToTop />
                <Switch>
                <Route exact path="/" render={() => !isLoggedIn() ? <PreLoginPage/> : <Redirect to={hash || "/home"}/> } />
                <Route path="/login" render={() => !isLoggedIn() ? <LoginPage/> : <Redirect to="/home"/> }/>
                <Route path="/free-trial" render={() => !isLoggedIn() ? <FreeTrialPage/> : <Redirect to="/home"/> }/>
                <Route path="/home" component={HomePage}/>
                <Route path="/map" component={MapPage}/>
                <Route path="/search-poi/:category" component={SearchPoiPage}/>
                <Route path="/search-poi" component={SearchPoiPage}/>
                <Route path="/featured-pois" component={FeaturedPoisPage}/>
                <Route path="/trending-pois" component={TrendingPoisPage}/>
                <Route path="/pois/:poiId" component={PoiDetailsPage} />
                <Route path="/social-wall" component={SocialWallPage}/>
                <Route path="/profile" component={ProfilePage}/>
                <Route path="/preferred-pois" component={PreferredPoisPage}/>
                <Route path="/card" component={CardPage}/>
                <Route path="/ios-registration" component={IOSRegsitrationPage}/>
                <Route path="/thank-you" component={ThankYouPage}/>
                </Switch>
            </div>
        </HashRouter>;
    }
}
;

export default App;
